import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SectionHeaderGapModule } from 'src/app/shared/section-header-gap/section-header-gap.module';
import { SectionGiftBooksModule } from 'src/app/shared/section-gift-books/section-gift-books.module';
import { SectionGiftCartModule } from 'src/app/shared/section-gift-cart/section-gift-cart.module';
import { SectionGiftCheckoutModule } from 'src/app/shared/section-gift-checkout/section-gift-checkout.module';
import { ImageTitleModule } from '@studiobuki/web-core/lib/image-title';
import { GiftBuySpecialPageComponent } from './gift-buy-special-page.component';

@NgModule({
  declarations: [GiftBuySpecialPageComponent],
  imports: [
    CommonModule,
    ImageTitleModule,
    SectionHeaderGapModule,
    SectionGiftBooksModule,
    SectionGiftCartModule,
    SectionGiftCheckoutModule,
  ],
})
export class GiftBuySpecialPageModule {}
